import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { graphqlRequest } from '@/api/amplify/helpers';
import { appsByAppKey } from '@/graphql/queries';
import { app } from '@/types/entities';
import { appView, convertAppToView } from '@/utils/entityViews/app';
import { useCallback } from 'react';
import { useCurrentApp } from '@/stores/userDataStore';

export const useAppsByAppKey = (appKey: string): UseQueryResult<[appView]> => {
  const { isLoggedIn } = useCurrentApp();
  return useQuery({
    queryKey: ['useAppsByAppKey', appKey],
    queryFn: async () => {
      const {
        data: {
          appsByAppKey: { items: apps },
        },
      } = await graphqlRequest({
        query: appsByAppKey,
        variables: { appKey },
      });
      return apps;
    },
    select: useCallback((data) => data.map(convertAppToView), []),
    enabled: !!appKey && isLoggedIn,
    staleTime: Infinity,
  });
};

export const useAppsByAppKeyPolling = (appKey: string): UseQueryResult<[app]> => {
  const { isLoggedIn } = useCurrentApp();
  return useQuery({
    queryKey: ['useAppsByAppKeyPolling', appKey],
    queryFn: async () => {
      const {
        data: {
          appsByAppKey: { items: apps },
        },
      } = await graphqlRequest({
        query: appsByAppKey,
        variables: { appKey },
      });

      return apps;
    },
    refetchInterval: 4000,
    enabled: !!appKey && isLoggedIn,
  });
};
